export default "<img [attr.src]=\"url | getAttachment | async\">\n\n\n\n";